export default {
  isActive: true,
  isDialogOpen: false
};